import { useMemo } from "react";

export default function useReferral(code) {
	const value = useMemo(() => {
		const q = new URLSearchParams(window.location.search);
		const v = q.get(code);
		return v;
	}, [code]);
	return value;
}